// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment_overview_outgoing_transfer_success_container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.payment_overview_outgoing_transfer_success_container > h2 {
    margin-top: 30px;
    font-size: 37px;
}

.payment_overview_outgoing_transfer_success_container > img {
    width: 80%;
    max-width: 170px;
    margin-top: 40px;
    margin-bottom: 40px;
}

.payment_overview_outgoing_transfer_success_container > p {
    font-size: 20px;
    max-width: 400px;
    text-align: center;
    font-weight: 600;
}

.payment_overview_outgoing_transfer_success_container_title {
    font-size: 37px;
    color: #191818;
    text-align: center;
    padding-top: 20px;
}

.payment_overview_outgoing_transfer_success_container_box {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 40px;
}

.payment_overview_outgoing_transfer_success_container_box_title {
    color: #7C828A;
    font-size: 20px;
    font-weight: bold;
}

.payment_overview_outgoing_transfer_success_container_box_edit {
    font-size: 20px;
    font-weight: normal;
    color: #53B6F9;
    text-decoration: underline;
    cursor: pointer;
}

.payment_overview_outgoing_transfer_success_container_box_sub_title {
    font-size: 20px;
    color: #7C828A;
}

.payment_overview_outgoing_transfer_success_container_box_amount {
    font-size: 20px;
    color: #3D3D8E;
    font-weight: bold;
}

.payment_overview_outgoing_transfer_success_container_box_underline {
    width: 100%;
    height: 1px;
    background-color: #707070;
    margin-top: 20px;
    margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Modals/PaymentsPage/OutgoingWireTransferModal/OutgoingWireTransferModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".payment_overview_outgoing_transfer_success_container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.payment_overview_outgoing_transfer_success_container > h2 {\n    margin-top: 30px;\n    font-size: 37px;\n}\n\n.payment_overview_outgoing_transfer_success_container > img {\n    width: 80%;\n    max-width: 170px;\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n\n.payment_overview_outgoing_transfer_success_container > p {\n    font-size: 20px;\n    max-width: 400px;\n    text-align: center;\n    font-weight: 600;\n}\n\n.payment_overview_outgoing_transfer_success_container_title {\n    font-size: 37px;\n    color: #191818;\n    text-align: center;\n    padding-top: 20px;\n}\n\n.payment_overview_outgoing_transfer_success_container_box {\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 40px;\n}\n\n.payment_overview_outgoing_transfer_success_container_box_title {\n    color: #7C828A;\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.payment_overview_outgoing_transfer_success_container_box_edit {\n    font-size: 20px;\n    font-weight: normal;\n    color: #53B6F9;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.payment_overview_outgoing_transfer_success_container_box_sub_title {\n    font-size: 20px;\n    color: #7C828A;\n}\n\n.payment_overview_outgoing_transfer_success_container_box_amount {\n    font-size: 20px;\n    color: #3D3D8E;\n    font-weight: bold;\n}\n\n.payment_overview_outgoing_transfer_success_container_box_underline {\n    width: 100%;\n    height: 1px;\n    background-color: #707070;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
